//#endregion
//#region src/version.ts
const PACKAGE_VERSION = "1.6.2";
//#endregion
export { PACKAGE_VERSION as t };
